import type * as ents from '@attain-apps/entities'

import type { Plugin } from './plugin'

export class Selectors {
  /**
   * Returns true if the given process is marked for stopping
   * (i.e. the stop confirmation dialog should be shown)
   */
  public readonly isMarkedForStop
  /**
   * Returns true if the {@link ents.core.relay.processes.Process} is expanded in the sidebar
   */
  public readonly isProcessExpanded
  constructor(plugin: Plugin) {
    this.isMarkedForStop = plugin.feature.createSelectorMethod(
      ({ processId }: { processId: ents.core.relay.processes.Process.Id }) =>
        plugin.feature.state.project(
          state => state.stoppingProcessId === processId,
        ).asSelector,
    )
    this.isProcessExpanded = plugin.feature.createSelectorMethod(
      ({
        process,
        processId,
      }: ExactlyOneOf<{
        process: ents.core.relay.processes.Process
        processId: ents.core.relay.processes.Process.Id
      }>) =>
        plugin.feature.state.project(state => {
          if (process) {
            processId = process.id
          }

          return !!processId && state.expandLookup[processId]
        }).asSelector,
    )
  }
}
